export const AppPopup = (props: any) => (
  <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_4983_68320" maskUnits="userSpaceOnUse" x="4" y="4" width="32" height="32">
      <path
        d="M28.8102 16.7269C31.8018 16.7269 34.2269 14.3018 34.2269 11.3102C34.2269 8.31868 31.8018 5.89355 28.8102 5.89355C25.8187 5.89355 23.3936 8.31868 23.3936 11.3102C23.3936 14.3018 25.8187 16.7269 28.8102 16.7269Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M28.8102 34.2269C31.8018 34.2269 34.2269 31.8018 34.2269 28.8102C34.2269 25.8187 31.8018 23.3936 28.8102 23.3936C25.8187 23.3936 23.3936 25.8187 23.3936 28.8102C23.3936 31.8018 25.8187 34.2269 28.8102 34.2269Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M11.3102 16.7269C14.3018 16.7269 16.7269 14.3018 16.7269 11.3102C16.7269 8.31868 14.3018 5.89355 11.3102 5.89355C8.31868 5.89355 5.89355 8.31868 5.89355 11.3102C5.89355 14.3018 8.31868 16.7269 11.3102 16.7269Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M11.3102 34.2269C14.3018 34.2269 16.7269 31.8018 16.7269 28.8102C16.7269 25.8187 14.3018 23.3936 11.3102 23.3936C8.31868 23.3936 5.89355 25.8187 5.89355 28.8102C5.89355 31.8018 8.31868 34.2269 11.3102 34.2269Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
    </mask>
    <g mask="url(#mask0_4983_68320)">
      <path d="M0.0605469 0.0605469H40.0605V40.0605H0.0605469V0.0605469Z" fill="#BBD0FB" />
    </g>
  </svg>
);
